import React, { useEffect } from 'react';
import { cookies, CCSRFToken } from 'libs/api/apiClient';
import { userLogout } from 'libs/api/user';
import { ERoute } from 'enums/route.enum';
import { Button, Row, Col, Typography } from 'antd';
import styled from 'styled-components';
import { FormWrapper, device } from 'GlobalStyles';
import LoginBackgroundSource from 'assets/images/banners/login.webp';
import TenantSource_LG from 'assets/images/logos/lg.svg';
import TenantSource_DN from 'assets/images/logos/dn.png';
import LogoSource from 'assets/images/logos/logo.svg';
import { showNotification } from 'libs/utils';
import { useRouteMatch } from 'react-router-dom';
import { RouteMatch } from 'modules/types';

const { Title, Text } = Typography;

const KaitusLogoImage = styled.img`
  width: 150px;
  margin-right: 50px;
  cursor: pointer;

  @media screen and ${device.md} {
    width: 133px;
    margin-right: 20px;
  }
`;

export const LogoImage = (source: string) => {
  return <KaitusLogoImage alt='logo' src={source} />;
};

const Complete = () => {
  useEffect(() => {
    showNotification('success', '테스트를 종료합니다. 감사합니다.') 
    setTimeout(function() {
      onClickComplete()
   }, 3000);
  }, []);

  const baseUrl = ERoute.KaitusComplete
  const match = useRouteMatch(baseUrl);
  const { tenant_id } = (match?.params as RouteMatch) || {};
  
  async function onClickComplete() {
    try {
      await userLogout();
      cookies.remove('sessionid');
      cookies.remove(CCSRFToken);
      window.location.href = `${ERoute.KaitusLogin.replace(':tenant_id', tenant_id)}`;
      window.localStorage.removeItem(CCSRFToken);
    } catch (e) {
      throw e;
    }
  }

  if (tenant_id === 'dn') {
    return (
      <Row style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <Col xs={0} sm={0} md={0} lg={12} xl={12}>
          <img alt='' src={LoginBackgroundSource} style={{ width: '100%', height: '100%' }} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <FormWrapper style={{ maxWidth: '500px' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Row>
              <Col className='logo-image'>{LogoImage(LogoSource)}</Col>
              <Col style={{ marginTop: '3px' }} className='logo-image'>{LogoImage(TenantSource_DN)}</Col>
            </Row>
            <br />
            <br />
            <br />
            <Title level={2}>Assessment 종료</Title>
            <Text style={{ marginTop: '50px', marginBottom: '30px', display: 'inline-block' }}>
            지난 한주 과정에 열심히 참여해주신 모든 여러분께 감사의 말씀 전합니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
            Assement 결과는 개별적으로 전달드리겠습니다.
            </Text>
            <br />
            <br />
            <br />
          </FormWrapper>
        </Col>
      </Row>
    );
  } else if (tenant_id === 'lg') {
    return (
      <Row style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <Col xs={0} sm={0} md={0} lg={12} xl={12}>
          <img alt='' src={LoginBackgroundSource} style={{ width: '100%', height: '100%' }} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <FormWrapper style={{ maxWidth: '500px' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Row>
              <Col className='logo-image'>{LogoImage(LogoSource)}</Col>
              <Col className='logo-image'>{LogoImage(TenantSource_LG)}</Col>
            </Row>
            <br />
            <br />
            <br />
            <Title level={2}>Assessment 종료</Title>
            <Text style={{ marginTop: '50px', marginBottom: '30px', display: 'inline-block' }}>
            Assessment에 응시하시느라 대단히 수고 많으셨습니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
            Assement 결과는 개별적으로 전달드리겠습니다.
            </Text>
            <Text style={{ marginBottom: '30px', display: 'inline-block' }}>
            * Assessment 결과는 '미래사업가 Essential' 러닝 그룹 구성에 반영될 예정입니다.
            </Text>
            <br />
            <br />
            <br />
          </FormWrapper>
        </Col>
      </Row>
    );
  } else {
    return (
      <div></div>
    )
  }
};

export default Complete;
